import React, { useState, useEffect } from "react";
import { getData, getOneData, postData } from "../components/helpers/Data";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { Spinner } from "../components/helpers/Spinner";
import "chart.js/auto";
import { Chart } from "react-chartjs-2";

const Home = () => {
  const [mostSalesNos, setMostSalesNos] = useState([]);
  const [mostSalesCash, setMostSalesCash] = useState([]);
  const [stockRestocking, setStockRestocking] = useState([]);
  const [stockExpiry, setStockExpiry] = useState([]);

  const chartMostSalesNoData = {
    labels: mostSalesNos.map((item) => item.manufacturer_item),
    datasets: [
      {
        data: mostSalesNos.map((item) => item.quantity),
        backgroundColor: [
          "#800080",
          "#FF6384",
          "#FFC0CB",
          "#0275d8",
          "#5cb85c",
          "#5bc0de",
          "#f0ad4e",
          "#d9534f",
          "#36A2EB",
          "#FFCE56",
        ], // You can customize colors
        hoverBackgroundColor: [
          "#800080",
          "#FF6384",
          "#FFC0CB",
          "#0275d8",
          "#5cb85c",
          "#5bc0de",
          "#f0ad4e",
          "#d9534f",
          "#36A2EB",
          "#FFCE56",
        ],
      },
    ],
  };
  const chartMostSalesCashData = {
    labels: mostSalesCash.map((item) => item.manufacturer_item),
    datasets: [
      {
        data: mostSalesCash.map((item) => item.trans_ttl),
        backgroundColor: [
          "#FFCE56",
          "#5bc0de",
          "#5cb85c",
          "#0275d8",
          "#FF6384",
          "#d9534f",
          "#FFC0CB",
          "#f0ad4e",
          "#800080",
          "#36A2EB",
        ], // You can customize colors
        hoverBackgroundColor: [
          "#FFCE56",
          "#5bc0de",
          "#5cb85c",
          "#0275d8",
          "#FF6384",
          "#d9534f",
          "#FFC0CB",
          "#f0ad4e",
          "#800080",
          "#36A2EB",
        ],
      },
    ],
  };

  useEffect(() => {
    setMostSalesNos([]);
    setMostSalesCash([]);
    setStockRestocking([]);
    setStockExpiry([]);
    document.getElementById("spinner").style.display = "block";
    getData("home_reports")
      .then((data) => {
        setMostSalesNos(data.most_sales_in_nos);
        setMostSalesCash(data.most_sales_in_cash);
        setStockRestocking(data.stock_restocking);
        setStockExpiry(data.stock_expiry);

        document.getElementById("spinner").style.display = "none";
      })
      .catch((error) => console.log(error));
  }, []);

  return (
    <div>
      <section id="rejection_rate" className="project-tab">
        <div className="row">
          <div className="col-md-6 card p-2  mr-2" style={{ height: "300px" }}>
            <span className="text text-success font-weight-bolder">
              Stock Expiry
            </span>
            <hr />
            <ReactHTMLTableToExcel
              className="btn btn-sm btn-success"
              id="tbl_1"
              table="tbl1"
              filename="expiry"
              sheet="expiry"
              buttonText="Export"
            />
            <table
              className="table table-bordered table-sm table-stripped"
              id="tbl1"
              style={{ maxHeight: "200px" }}
            >
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Stocked</th>
                  <th>Available</th>
                  <th>Expiry Date</th>
                  <th>Expiry</th>
                </tr>
              </thead>
              <tbody>
                {stockExpiry.map((dt) => {
                  return (
                    <tr key={dt.id}>
                      <td>{dt.manufacturer_item}</td>
                      <td>{dt.quantity_stocked}</td>
                      <td>{dt.quantity_available}</td>
                      <td>{dt.expiry_date}</td>
                      <td>
                        {dt.date_diff.includes("Expired") ? (
                          <span style={{ color: "red", fontWeight: "bolder" }}>
                            {dt.date_diff}
                          </span>
                        ) : dt.date_diff.includes("Expiring") ? (
                          <span style={{ color: "red", fontWeight: "bolder" }}>
                            {dt.date_diff}
                          </span>
                        ) : (
                          <span
                            style={{ color: "green", fontWeight: "bolder" }}
                          >
                            {dt.date_diff}
                          </span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Spinner />
          </div>
          <div className="col-md-5 card p-2" style={{ height: "300px" }}>
            <span className="text text-success font-weight-bolder">
              Stock Restocking
            </span>
            <hr />
             <ReactHTMLTableToExcel
              className="btn btn-sm btn-success"
              id="tbl_2"
              table="tbl2"
              filename="restocking"
              sheet="restocking"
              buttonText="Export"
            />
            <table
              className="table table-bordered table-sm table-stripped"
              id="tbl2"
              style={{ maxHeight: "200px" }}
            >
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Stocked</th>
                  <th>Sold</th>
                  <th>expired/spoilt</th>
                  <th>available</th>
                </tr>
              </thead>
              <tbody>
                {stockRestocking.map((dt) => {
                  return (
                    <tr key={dt.id}>
                      <td>{dt.manufacturer_item}</td>
                      <td>{dt.quantity_stocked}</td>
                      <td>{dt.quantity_sold}</td>
                      <td>{dt.quantity_expired_or_spoilt}</td>
                      <td>{dt.quantity_available}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Spinner />
          </div>
          <div className="col-md-6  card p-2 mr-2">
            <span className="text text-success font-weight-bolder">
              Top 10 Sales in numbers
            </span>
            <hr />
            <div style={{ maxWidth: "300px", margin: "0 auto" }}>
              <Chart type="doughnut" data={chartMostSalesNoData} />
            </div>
          </div>
          <div className="col-md-5 card p-2">
            <span className="text text-success font-weight-bolder">
              Top 10 Sales in Cash
            </span>
            <hr />
            <div style={{ maxWidth: "300px", margin: "0 auto" }}>
              <Chart type="pie" data={chartMostSalesCashData} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
